import { combineReducers } from 'redux';
import { createReducer, defaultListInitialState, defaultGetReducer, createRequestReducer } from 'utils';
import {
  GET_SITE_CONFIG,
  GET_COUNTRIES,
  GET_POPULAR_DESTINATIONS,
  GET_BIKE_TYPES,
  GET_EXTRA_ITEM_TYPES,
  DATA_SET_CURRENCY
} from '../constants';

const currency = createReducer('EUR', {
  [DATA_SET_CURRENCY]: (state, action) => {
    return action.value;
  }
});

const siteConfig = createReducer(null, {
  [GET_SITE_CONFIG]: (state, action) => createRequestReducer(state, action, {
    SUCCESS: (state, action) => {
      return action.response;
    }
  })
});

const countriesInitialState = defaultListInitialState();
const countries = createReducer(countriesInitialState, {
  [GET_COUNTRIES]: defaultGetReducer
});

const popularDestinationsInitialState = defaultListInitialState();
const popularDestinations = createReducer(popularDestinationsInitialState, {
  [GET_POPULAR_DESTINATIONS]: defaultGetReducer
});

const bikeTypesInitialState = defaultListInitialState();
const bikeTypes = createReducer(bikeTypesInitialState, {
  [GET_BIKE_TYPES]: defaultGetReducer
});

const extraItemTypesInitialState = defaultListInitialState();
const extraItemTypes = createReducer(extraItemTypesInitialState, {
  [GET_EXTRA_ITEM_TYPES]: defaultGetReducer
});

export default combineReducers({
  currency,
  siteConfig,
  countries,
  popularDestinations,
  bikeTypes,
  extraItemTypes
});



// WEBPACK FOOTER //
// ./src/reducers/app.js